module.exports = __webpack_public_path__ + "static/media/patient-search.20d0cf70.png";